require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-melbournes-love-affair-with-warehouse-conversions.json") })
        }
      }, "path---news-melbournes-love-affair-with-warehouse-conversions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-melbournes-love-affair-with-warehouse-conversions!./.cache/json/news-melbournes-love-affair-with-warehouse-conversions.json
// module id = 831
// module chunks = 231608221292675